export default __webpack_public_path__ + "static/media/B52_18.ac929207.webp";